export default "__VITE_ASSET__fL4udONK__"